module.exports = __webpack_public_path__ + "img/dd1_scheme.5df62fe9.png";